export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 12.5c3.094 0 6 2.042 6 5a1 1 0 01-1 1H7a1 1 0 01-1-1c0-2.958 2.906-5 6-5zm0 2c-1.87 0-3.231.913-3.759 2h7.518c-.528-1.087-1.889-2-3.759-2zM12 5.5a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.5 2a1 1 0 011 1v18a1 1 0 01-1 1h-17a1 1 0 01-1-1v-1H1v-2h1.5V6H1V4h1.5V3a1 1 0 011-1h17zm-16 18h15V4h-15v16z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};